export const emptyReservation = () => {
    return {
        offer_id: null,

        title: '',
        routes: [],

        passengers: 2,
        adults: 2,
        children: 0,
        infants: 0,
        booster_seats: 0,
        baby_seats: 0,
        infant_seats: 0,
        luggage: 0,

        start_price: null,
        price: null,
        payment: null,
        payment_type: null,
        vehicle: null,

        fullname: '',
        phone: '',
        email: '',
        agent_email: '',

        // fullname: 'Harrys Nikoloudakis',
        // phone: '+306932394558',
        // email: 'harrysnikoloudakis@gmail.com',
        room_no: '',

        notes: null,
    };
}

export const emptyRoute = (route_type = null) => {
    return {
        transfer_id: null,
        tour_id: null,
        route_type,
        transfer_at: null,
        pickup_id: null,
        pickup_name: '',
        pickup_address: '',
        drop_id: null,
        drop_name: '',
        drop_address: '',
        flight_no: '',
        price: 0,
    }
}